export function encodeBase64Browser(input: string): string {
  const uint8 = new TextEncoder().encode(input);
  let binary = '';
  for (let i = 0; i < uint8.length; i++)
    binary += String.fromCharCode(uint8[i]);
  return btoa(binary);
}

export function decodeBase64Browser(b64: string): string {
  const binary = atob(b64);
  const len = binary.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) bytes[i] = binary.charCodeAt(i);
  return new TextDecoder().decode(bytes);
}
